// extracted by mini-css-extract-plugin
export default {"stateReasonLink":"ClosedEvent-module__stateReasonLink--YEqx6","closerLink":"ClosedEvent-module__closerLink--GQXSl"};